import React, { FC } from 'react'
import { Spinner } from '@ui-kitten/components'

interface ILoadingIndicatorProps {
  maxWidth?: number
}

export const LoadingIndicator: FC<ILoadingIndicatorProps> = ({ maxWidth }) => (
  // better to use built-in DataTable indicator,
  // for now there is a problem with scrollbars
  // and indicator position on tables with fixed width
  <div
    style={{
      width: '100%',
      maxWidth: maxWidth,
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <Spinner />
  </div>
)
